import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { confirmDialog } from '../utils/confirm';
import {
  CYCLES, CYCLE_LABELS, CYCLE_COLORS,
  LEVELS_BY_CYCLE,
} from '../utils/cycle.helpers';

export default function Structure() {
  const [tab, setTab] = useState('cycles');
  return (
    <>
      <div className="tabs">
        <button className={`tab ${tab === 'cycles' ? 'active' : ''}`} onClick={() => setTab('cycles')}>Cycles & Niveaux</button>
        <button className={`tab ${tab === 'classes' ? 'active' : ''}`} onClick={() => setTab('classes')}>Classes</button>
        <button className={`tab ${tab === 'matieres' ? 'active' : ''}`} onClick={() => setTab('matieres')}>Matières</button>
        <button className={`tab ${tab === 'annee' ? 'active' : ''}`} onClick={() => setTab('annee')}>Année scolaire</button>
      </div>
      {tab === 'cycles'   && <CyclesNiveaux />}
      {tab === 'classes'  && <Classes />}
      {tab === 'matieres' && <Matieres />}
      {tab === 'annee'    && <AnneeScolaire />}
    </>
  );
}

// ── Cycles & Niveaux ──────────────────────────────────
function CyclesNiveaux() {
  const [cycles, setCycles]   = useState([]);
  const [modal, setModal]     = useState(null);
  const [levelModal, setLevelModal] = useState(null);
  const [error, setError]     = useState('');

  function load() {
    api.get('/catalog/cycles').then(setCycles).catch((e) => setError(e.message));
  }
  useEffect(load, []);

  async function initUemoa() {
    try {
      await api.post('/catalog/cycles/seed-uemoa', {});
      load();
    } catch (e) { setError(e.message); }
  }

  async function delCycle(id) {
    if (!(await confirmDialog({ title: 'Supprimer le cycle', message: 'Supprimer ce cycle et tous ses niveaux ?', danger: true }))) return;
    try { await api.delete(`/catalog/cycles/${id}`); load(); } catch (e) { setError(e.message); }
  }

  async function delLevel(id) {
    if (!(await confirmDialog({ title: 'Supprimer le niveau', message: 'Supprimer ce niveau ?', danger: true }))) return;
    try { await api.delete(`/catalog/levels/${id}`); load(); } catch (e) { setError(e.message); }
  }

  return (
    <>
      {error && <div className="form-error">{error}</div>}

      {cycles.length === 0 && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-body" style={{ padding: 24, textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: 12 }}>🌍</div>
            <h3 style={{ marginBottom: 8 }}>Aucun cycle configuré</h3>
            <p style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 16 }}>
              Initialisez automatiquement les 4 cycles UEMOA (Pré-Scolaire, Élémentaire, Post-Élémentaire, Secondaire) avec leurs niveaux.
            </p>
            <button className="btn" onClick={initUemoa} style={{ width: 'auto', padding: '0 28px' }}>
              🚀 Initialiser les cycles UEMOA
            </button>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
        {cycles.map((cy) => {
          const color = CYCLE_COLORS[cy.code] || 'var(--primary)';
          const defaultLevels = LEVELS_BY_CYCLE[cy.code] || [];
          return (
            <div key={cy.id} className="card" style={{ borderTop: `3px solid ${color}` }}>
              <div className="card-head">
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                  <div style={{ width: 10, height: 10, borderRadius: '50%', background: color }} />
                  <h2 style={{ color }}>{cy.name}</h2>
                  <span className="badge gray" style={{ fontSize: 10 }}>{cy.code}</span>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="btn-ghost btn-sm" onClick={() => setLevelModal({ cycleId: cy.id, cycleName: cy.name, code: '' })}>+ Niveau</button>
                  <button className="link-danger" onClick={() => delCycle(cy.id)}>✕</button>
                </div>
              </div>
              <div className="card-body" style={{ padding: 0 }}>
                {(cy.levels || []).length === 0 ? (
                  <div style={{ padding: 12 }}>
                    <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8 }}>Niveaux suggérés :</div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {defaultLevels.map((l) => (
                        <button key={l.code} className="btn-ghost btn-sm" style={{ fontSize: 11 }}
                          onClick={async () => {
                            try { await api.post('/catalog/levels', { cycleId: cy.id, name: l.label, code: l.code }); load(); }
                            catch (e) { setError(e.message); }
                          }}>
                          + {l.code}
                        </button>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div>
                    {(cy.levels || []).sort((a, b) => (a.order || 0) - (b.order || 0)).map((lv) => (
                      <div key={lv.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 14px', borderBottom: '0.5px solid var(--line)' }}>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                          <span style={{ fontSize: 12, fontWeight: 600, color, minWidth: 40 }}>{lv.code}</span>
                          <span style={{ fontSize: 13 }}>{lv.name}</span>
                          <span className="badge gray" style={{ fontSize: 10 }}>{lv._count?.classes || 0} classe(s)</span>
                        </div>
                        <button className="link-danger" onClick={() => delLevel(lv.id)}>✕</button>
                      </div>
                    ))}
                    <div style={{ padding: 8, textAlign: 'right' }}>
                      <button className="btn-ghost btn-sm" onClick={() => setLevelModal({ cycleId: cy.id, cycleName: cy.name, code: '' })}>
                        + Ajouter un niveau
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: 16 }}>
        <button className="btn-ghost btn-sm" onClick={() => setModal({ name: '', code: '' })}>+ Nouveau cycle</button>
      </div>

      {modal && <CycleModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
      {levelModal && <LevelModal initial={levelModal} onClose={() => setLevelModal(null)} onSaved={() => { setLevelModal(null); load(); }} />}
    </>
  );
}

function CycleModal({ initial, onClose, onSaved }) {
  const [f, setF] = useState({ name: '', code: '', ...initial });
  const [error, setError] = useState('');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  async function save() {
    if (!f.name) { setError('Nom obligatoire.'); return; }
    try {
      await api.post('/catalog/cycles', { name: f.name, code: f.code || f.name.toUpperCase().replace(/\s/g, '_') });
      onSaved();
    } catch (e) { setError(e.message); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Nouveau cycle</h2>
        {error && <div className="form-error">{error}</div>}
        <div className="field"><label>Nom *</label><input value={f.name} onChange={set('name')} placeholder="Ex: Pré-Scolaire" /></div>
        <div className="field"><label>Code</label><input value={f.code} onChange={set('code')} placeholder="Ex: PRESCOLAIRE" /></div>
        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <button className="btn" onClick={save} style={{ width: 'auto', padding: '0 20px' }}>Créer</button>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}

function LevelModal({ initial, onClose, onSaved }) {
  const [f, setF] = useState({ name: '', code: '', order: 1, ...initial });
  const [error, setError] = useState('');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const defaultLevels = LEVELS_BY_CYCLE[Object.keys(CYCLES).find((c) => c === initial.cycleName)] || [];

  async function save() {
    if (!f.name) { setError('Nom obligatoire.'); return; }
    try {
      await api.post('/catalog/levels', { cycleId: initial.cycleId, name: f.name, code: f.code || f.name.toUpperCase().slice(0, 6), order: Number(f.order) });
      onSaved();
    } catch (e) { setError(e.message); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Nouveau niveau — {initial.cycleName}</h2>
        {error && <div className="form-error">{error}</div>}
        <div className="two-col">
          <div className="field"><label>Nom *</label><input value={f.name} onChange={set('name')} placeholder="Ex: Cours d'Initiation" /></div>
          <div className="field"><label>Code</label><input value={f.code} onChange={set('code')} placeholder="Ex: CI" /></div>
        </div>
        <div className="field"><label>Ordre d'affichage</label><input type="number" min="1" value={f.order} onChange={set('order')} /></div>
        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <button className="btn" onClick={save} style={{ width: 'auto', padding: '0 20px' }}>Créer</button>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}

// ── Classes ───────────────────────────────────────────
function Classes() {
  const [classes, setClasses] = useState([]);
  const [cycles, setCycles]   = useState([]);
  const [modal, setModal]     = useState(null);
  const [filterCycle, setFilterCycle] = useState('');
  const [error, setError]     = useState('');

  function load() {
    api.get('/catalog/classes').then(setClasses).catch((e) => setError(e.message));
    api.get('/catalog/cycles').then(setCycles).catch(() => {});
  }
  useEffect(load, []);

  async function del(id) {
    if (!(await confirmDialog({ title: 'Supprimer', message: 'Supprimer cette classe ?', danger: true }))) return;
    try { await api.delete(`/catalog/classes/${id}`); load(); } catch (e) { setError(e.message); }
  }

  const filtered = classes.filter((c) => !filterCycle || c.level?.cycle?.code === filterCycle || c.cycleCode === filterCycle);

  return (
    <div className="card">
      <div className="card-head">
        <h2>Classes</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={filterCycle} onChange={(e) => setFilterCycle(e.target.value)} style={{ width: 180 }}>
            <option value="">Tous les cycles</option>
            {Object.entries(CYCLE_LABELS).map(([v, l]) => (
              <option key={v} value={v}>{l}</option>
            ))}
          </select>
          <button className="btn btn-sm" onClick={() => setModal({ name: '', levelId: '', capacity: 35 })}>+ Nouvelle classe</button>
        </div>
      </div>
      <div className="card-body">
        {error && <div className="form-error">{error}</div>}
        {filtered.length === 0 ? <div className="empty">Aucune classe.</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr><th>Classe</th><th>Cycle</th><th>Niveau</th><th className="num">Capacité</th><th className="num">Élèves</th><th></th></tr>
            </thead>
            <tbody>{filtered.map((c) => {
              const cycleCode = c.level?.cycle?.code || c.cycleCode;
              const color = CYCLE_COLORS[cycleCode] || 'var(--muted)';
              return (
                <tr key={c.id}>
                  <td><b>{c.name}</b></td>
                  <td>
                    {cycleCode && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12 }}>
                        <span style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />
                        {CYCLE_LABELS[cycleCode] || cycleCode}
                      </span>
                    )}
                  </td>
                  <td>{c.level?.name || '—'}</td>
                  <td className="num">{c.capacity || '—'}</td>
                  <td className="num">{c._count?.enrollments || 0}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="btn-ghost btn-sm" onClick={() => setModal(c)}>Modifier</button>
                    <button className="link-danger" onClick={() => del(c.id)}>Supprimer</button>
                  </td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
      </div>
      {modal && <ClasseModal initial={modal} cycles={cycles} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
    </div>
  );
}

function ClasseModal({ initial, cycles, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({ name: '', levelId: '', capacity: 35, ...initial });
  const [levels, setLevels] = useState([]);
  const [selCycle, setSelCycle] = useState(initial.level?.cycle?.code || '');
  const [error, setError] = useState('');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  useEffect(() => {
    if (selCycle) {
      api.get(`/catalog/levels?cycleCode=${selCycle}`).then(setLevels).catch(() => {});
    }
  }, [selCycle]);

  async function save() {
    if (!f.name) { setError('Nom obligatoire.'); return; }
    try {
      if (isEdit) await api.patch(`/catalog/classes/${initial.id}`, { name: f.name, capacity: Number(f.capacity), ...(f.levelId ? { levelId: f.levelId } : {}) });
      else await api.post('/catalog/classes', { name: f.name, levelId: f.levelId || undefined, capacity: Number(f.capacity) });
      onSaved();
    } catch (e) { setError(e.message); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{isEdit ? 'Modifier la classe' : 'Nouvelle classe'}</h2>
        {error && <div className="form-error">{error}</div>}
        <div className="field"><label>Cycle</label>
          <select value={selCycle} onChange={(e) => setSelCycle(e.target.value)}>
            <option value="">— Sélectionner un cycle —</option>
            {Object.entries(CYCLE_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
        {selCycle && (
          <div className="field"><label>Niveau</label>
            <select value={f.levelId} onChange={set('levelId')}>
              <option value="">— Sélectionner —</option>
              {levels.map((l) => <option key={l.id} value={l.id}>{l.name} ({l.code})</option>)}
            </select>
          </div>
        )}
        <div className="two-col">
          <div className="field"><label>Nom de la classe *</label><input value={f.name} onChange={set('name')} placeholder="Ex: CE1 A" /></div>
          <div className="field"><label>Capacité</label><input type="number" min="1" value={f.capacity} onChange={set('capacity')} /></div>
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <button className="btn" onClick={save} style={{ width: 'auto', padding: '0 20px' }}>{isEdit ? 'Enregistrer' : 'Créer'}</button>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}

// ── Matières ──────────────────────────────────────────
function Matieres() {
  const [subjects, setSubjects] = useState([]);
  const [modal, setModal]       = useState(null);
  const [filterCycle, setFilterCycle] = useState('');
  const [error, setError]       = useState('');

  function load() {
    api.get('/catalog/subjects').then(setSubjects).catch((e) => setError(e.message));
  }
  useEffect(load, []);

  async function del(id) {
    if (!(await confirmDialog({ title: 'Supprimer', message: 'Supprimer cette matière ?', danger: true }))) return;
    try { await api.delete(`/catalog/subjects/${id}`); load(); } catch (e) { setError(e.message); }
  }

  const filtered = subjects.filter((s) => !filterCycle || s.cycleCode === filterCycle);

  return (
    <div className="card">
      <div className="card-head">
        <h2>Matières</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={filterCycle} onChange={(e) => setFilterCycle(e.target.value)} style={{ width: 180 }}>
            <option value="">Tous les cycles</option>
            {Object.entries(CYCLE_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <button className="btn btn-sm" onClick={() => setModal({ name: '', code: '', defaultCoefficient: 1 })}>+ Nouvelle matière</button>
        </div>
      </div>
      <div className="card-body">
        {error && <div className="form-error">{error}</div>}
        {filtered.length === 0 ? <div className="empty">Aucune matière.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Matière</th><th>Code</th><th>Cycle</th><th className="num">Coeff. défaut</th><th></th></tr></thead>
            <tbody>{filtered.map((s) => {
              const color = CYCLE_COLORS[s.cycleCode] || 'var(--muted)';
              return (
                <tr key={s.id}>
                  <td><b>{s.name}</b></td>
                  <td className="mono">{s.code || '—'}</td>
                  <td>
                    {s.cycleCode && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12 }}>
                        <span style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />
                        {CYCLE_LABELS[s.cycleCode] || s.cycleCode}
                      </span>
                    )}
                  </td>
                  <td className="num">{s.defaultCoefficient || 1}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="btn-ghost btn-sm" onClick={() => setModal(s)}>Modifier</button>
                    <button className="link-danger" onClick={() => del(s.id)}>Supprimer</button>
                  </td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
      </div>
      {modal && <MatiereModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
    </div>
  );
}

function MatiereModal({ initial, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({ name: '', code: '', defaultCoefficient: 1, cycleCode: '', ...initial });
  const [vhh, setVhh] = useState(initial.vhhByClass || {});
  const [classes, setClasses] = useState([]);
  const [levelCycleMap, setLevelCycleMap] = useState({});
  const [error, setError] = useState('');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  useEffect(() => {
    api.get('/catalog/classes').then((list) => setClasses(list || [])).catch(() => {});
    api.get('/catalog/cycles').then((cyc) => {
      const map = {};
      (cyc || []).forEach((cy) => { (cy.levels || []).forEach((lv) => { map[lv.id] = cy.code; }); });
      setLevelCycleMap(map);
    }).catch(() => {});
  }, []);

  const filteredClasses = f.cycleCode ? classes.filter((c) => (c.level?.cycle?.code || c.cycleCode || levelCycleMap[c.levelId]) === f.cycleCode || c.level?.cycle?.name === CYCLE_LABELS[f.cycleCode]) : classes;

  function setVhhVal(classId, val) {
    setVhh((prev) => ({ ...prev, [classId]: val === '' ? undefined : Number(val) }));
  }

  async function save() {
    if (!f.name) { setError('Nom obligatoire.'); return; }
    try {
      const vhhByClass = Object.fromEntries(Object.entries(vhh).filter(([, v]) => v !== undefined && v !== '' && Number(v) > 0).map(([k, v]) => [k, Number(v)]));
      const payload = { name: f.name, code: f.code || f.name.slice(0, 6).toUpperCase(), defaultCoefficient: Number(f.defaultCoefficient), cycleCode: f.cycleCode || undefined, vhhByClass };
      if (isEdit) await api.patch(`/catalog/subjects/${initial.id}`, payload);
      else await api.post('/catalog/subjects', payload);
      onSaved();
    } catch (e) { setError(e.message); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560, width: '100%' }}>
        <h2>{isEdit ? 'Modifier la matière' : 'Nouvelle matière'}</h2>
        {error && <div className="form-error">{error}</div>}
        <div className="field"><label>Nom *</label><input value={f.name} onChange={set('name')} placeholder="Ex: Calcul" /></div>
        <div className="two-col">
          <div className="field"><label>Code</label><input value={f.code} onChange={set('code')} placeholder="Ex: CALC" /></div>
          <div className="field"><label>Coefficient par défaut</label><input type="number" min="0.5" step="0.5" value={f.defaultCoefficient} onChange={set('defaultCoefficient')} /></div>
        </div>
        <div className="field"><label>Cycle</label>
          <select value={f.cycleCode} onChange={set('cycleCode')}>
            <option value="">— Tous cycles —</option>
            {Object.entries(CYCLE_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>

        {classes.length > 0 && (
          <div style={{ marginTop: 16 }}>
            <label style={{ display: 'block', fontWeight: 600, fontSize: '0.85rem', marginBottom: 8, color: 'var(--muted)' }}>VHH réglementaire par classe (h/sem)</label>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid var(--line)' }}>
                    <th style={{ padding: '4px 8px', textAlign: 'left', color: 'var(--muted)', fontWeight: 500 }}>Classe</th>
                    <th style={{ padding: '4px 8px', textAlign: 'center', color: 'var(--muted)', fontWeight: 500, width: 110 }}>VHH (h/sem)</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClasses.length === 0 ? (
                    <tr><td colSpan={2} style={{ padding: '8px', color: 'var(--muted)', textAlign: 'center', fontSize: '0.82rem' }}>Aucune classe pour ce cycle.</td></tr>
                  ) : filteredClasses.map((c) => (
                    <tr key={c.id} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                      <td style={{ padding: '4px 8px' }}>{c.name}</td>
                      <td style={{ padding: '4px 8px', textAlign: 'center' }}>
                        <input
                          type="number" min="0" max="40" step="0.5"
                          value={vhh[c.id] ?? ''}
                          onChange={(e) => setVhhVal(c.id, e.target.value)}
                          placeholder="—"
                          style={{ width: 72, textAlign: 'center' }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button className="btn" onClick={save} style={{ width: 'auto', padding: '0 20px' }}>{isEdit ? 'Enregistrer' : 'Créer'}</button>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}

// ── Année scolaire ────────────────────────────────────
function AnneeScolaire() {
  const [years, setYears]   = useState([]);
  const [modal, setModal]   = useState(null);
  const [error, setError]   = useState('');

  function load() {
    api.get('/catalog/periods').then(setYears).catch((e) => setError(e.message));
  }
  useEffect(load, []);

  async function setActive(id) {
    try { await api.patch(`/catalog/periods/${id}`, { isCurrent: true }); load(); }
    catch (e) { setError(e.message); }
  }

  return (
    <div className="card">
      <div className="card-head">
        <h2>Années scolaires & Trimestres</h2>
        <button className="btn btn-sm" onClick={() => setModal({ name: '', startDate: '', endDate: '' })}>+ Nouvelle année</button>
      </div>
      <div className="card-body">
        {error && <div className="form-error">{error}</div>}
        {years.length === 0 ? <div className="empty">Aucune période configurée.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Nom</th><th>Début</th><th>Fin</th><th>Statut</th><th></th></tr></thead>
            <tbody>{years.map((y) => (
              <tr key={y.id}>
                <td><b>{y.name}</b></td>
                <td className="mono">{y.startDate ? new Date(y.startDate).toLocaleDateString('fr-FR') : '—'}</td>
                <td className="mono">{y.endDate ? new Date(y.endDate).toLocaleDateString('fr-FR') : '—'}</td>
                <td>
                  {y.isCurrent
                    ? <span className="badge green">● En cours</span>
                    : <button className="btn-ghost btn-sm" onClick={() => setActive(y.id)}>Définir active</button>}
                </td>
                <td style={{ textAlign: 'right' }}>
                  <button className="btn-ghost btn-sm" onClick={() => setModal(y)}>Modifier</button>
                </td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
        <div style={{ marginTop: 16, padding: '12px 14px', background: 'var(--surface-soft)', borderRadius: 8, fontSize: 12, color: 'var(--muted)' }}>
          📅 Année scolaire UEMOA : Octobre → Juillet
          <br />T1 : Oct–Jan · T2 : Fév–Avr · T3 : Mai–Juil
        </div>
      </div>
      {modal && <AnneeModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
    </div>
  );
}

function AnneeModal({ initial, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({ name: '', startDate: '', endDate: '', ...initial });
  const [error, setError] = useState('');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  async function save() {
    if (!f.name) { setError('Nom obligatoire.'); return; }
    try {
      const payload = { name: f.name, startDate: f.startDate || undefined, endDate: f.endDate || undefined };
      if (isEdit) await api.patch(`/catalog/periods/${initial.id}`, payload);
      else await api.post('/catalog/periods', payload);
      onSaved();
    } catch (e) { setError(e.message); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{isEdit ? "Modifier l'année" : 'Nouvelle année scolaire'}</h2>
        {error && <div className="form-error">{error}</div>}
        <div className="field"><label>Nom *</label><input value={f.name} onChange={set('name')} placeholder="Ex: 2025-2026" /></div>
        <div className="two-col">
          <div className="field"><label>Date de début</label><input type="date" value={f.startDate?.slice(0, 10) || ''} onChange={set('startDate')} /></div>
          <div className="field"><label>Date de fin</label><input type="date" value={f.endDate?.slice(0, 10) || ''} onChange={set('endDate')} /></div>
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <button className="btn" onClick={save} style={{ width: 'auto', padding: '0 20px' }}>{isEdit ? 'Enregistrer' : 'Créer'}</button>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}
